(function(){
  const root=document.querySelector('.bliss-spa-calculator');
  let type='portable', shape='rectangle';
  const $=s=>root.querySelector(s), $$=s=>root.querySelectorAll(s);
  function mult(){return type==='portable'?2.4:4.8}
  function formula(){return shape==='round'?`Diameter × Diameter × Depth × ${mult()} ÷ 1728`:`Length × Width × Depth × ${mult()} ÷ 1728`;}
  function update(){
    $$('[data-type]').forEach(b=>b.classList.toggle('active',b.dataset.type===type));
    $$('[data-shape]').forEach(b=>b.classList.toggle('active',b.dataset.shape===shape));
    $('#measure-title').textContent=type==='portable'?'Enter outside cabinet measurements':'Enter actual water measurements';
    $('#depth-help').textContent=type==='portable'?'Cabinet depth in inches':'Water depth in inches';
    $('#round-depth-help').textContent=type==='portable'?'Cabinet depth in inches':'Water depth in inches';
    $('#formula').textContent=formula();
    $('#rect-fields').style.display=shape==='round'?'none':'grid';
    $('#round-fields').style.display=shape==='round'?'grid':'none';
    $('#error').classList.remove('show');
  }
  function val(id){ const n=Number($(id).value); return Number.isFinite(n)&&n>0?n:null; }
  function calculate(){
    $('#error').classList.remove('show');
    let gallons=0;
    if(shape==='round'){ const d=val('#diameter'), h=val('#round-depth'); if(!d||!h) return $('#error').classList.add('show'); gallons=d*d*h*mult()/1728; }
    else { const l=val('#length'), w=val('#width'), h=val('#depth'); if(!l||!w||!h) return $('#error').classList.add('show'); gallons=l*w*h*mult()/1728; }
    const g=Math.ceil(gallons), litres=Math.ceil(g*3.78541);
    $('#result').textContent=g.toLocaleString()+' gallons';
    $('#result-sub').textContent='About '+litres.toLocaleString()+' litres. Use this as an estimate for chemical dosing.';
  }
  $$('[data-type]').forEach(b=>b.addEventListener('click',()=>{type=b.dataset.type; update();}));
  $$('[data-shape]').forEach(b=>b.addEventListener('click',()=>{shape=b.dataset.shape; update();}));
  $('#calc').addEventListener('click',calculate);
  update();
})();